// extracted by mini-css-extract-plugin
module.exports = {"button":"MenuButton_button__16TvE"};